export const ErrorIcon = () => (
    <svg
        data-testid={'errorIcon'}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M6.56624 17C5.78895 17 5.30883 16.152 5.70875 15.4855L11.1426 6.42915C11.531 5.78181 12.4691 5.78182 12.8575 6.42915L18.2914 15.4855C18.6913 16.152 18.2112 17 17.4339 17H6.56624ZM11.9965 15C12.1655 15 12.3084 14.9428 12.425 14.8285C12.5417 14.7142 12.6 14.5725 12.6 14.4035C12.6 14.2345 12.5429 14.0917 12.4286 13.975C12.3142 13.8583 12.1726 13.8 12.0036 13.8C11.8346 13.8 11.6917 13.8572 11.575 13.9715C11.4584 14.0858 11.4 14.2275 11.4 14.3965C11.4 14.5655 11.4572 14.7083 11.5715 14.825C11.6859 14.9417 11.8275 15 11.9965 15ZM11.4 12.4C11.4 12.7314 11.6687 13 12 13C12.3314 13 12.6 12.7314 12.6 12.4V10.4C12.6 10.0686 12.3314 9.8 12 9.8C11.6687 9.8 11.4 10.0686 11.4 10.4V12.4Z"
            fill="#D32F2F"
        />
    </svg>
);
